(function () {
  if (window.location.pathname !== '/cart') return;
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
    var drawer = document.querySelector('pagepilot-cart-drawer-component');
    if (drawer) window.location.reload();
  });
})();
